import React, { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { LifeBuoy } from "lucide-react";

export function SupportDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async () => {
    if (!form.name || !form.email || !form.message) { toast.error("Preencha nome, e-mail e mensagem"); return; }
    setBusy(true);
    try {
      await api.post("/support", form);
      toast.success("Mensagem enviada! Em breve retornaremos.");
      setForm({ name: "", email: "", subject: "", message: "" });
      setOpen(false);
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro ao enviar"); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {trigger || <button className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:underline" data-testid="open-support-btn"><LifeBuoy className="h-4 w-4" /> Fale com o suporte</button>}
      </DialogTrigger>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Fale com o suporte</DialogTitle>
          <DialogDescription>Envie sua dúvida ou problema. Respondemos por e-mail.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div><Label>Nome</Label><Input value={form.name} onChange={set("name")} className="mt-1 h-11" data-testid="support-name" /></div>
          <div><Label>E-mail</Label><Input type="email" value={form.email} onChange={set("email")} className="mt-1 h-11" data-testid="support-email" /></div>
          <div><Label>Assunto</Label><Input value={form.subject} onChange={set("subject")} className="mt-1 h-11" data-testid="support-subject" /></div>
          <div><Label>Mensagem</Label><Textarea value={form.message} onChange={set("message")} rows={4} className="mt-1" data-testid="support-message" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
          <Button onClick={submit} disabled={busy} data-testid="support-send-btn">{busy ? "Enviando..." : "Enviar"}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
